<script setup>
import { ref, provide } from 'vue';

const container = ref(null);

provide('portalContainerRef', container);
</script>

<template>
    <slot />
    <div ref="container" data-test="portal-container" class="absolute top-0 left-0"></div>
</template>

<style scoped></style>
